// Mock data for Kshitij's portfolio

export const personalInfo = {
  name: "KJ",
  title: "UX/UI Designer",
  tagline: "Turning ideas into clean, fast, and functional software.",
  email: "kshitijjadhav257@gmail.com",
  location: "Navi Mumbai, India",
  social: {
    github: "https://github.com/kshitij-create",
    instagram: "https://www.instagram.com/kshitij_257/",
  }
};

export const aboutData = {
  intro: "A frontend developer exploring the intersection of software, AI, and design. A thinker who builds practical and elegant solutions",
  description: "I’ve grown from a self-taught frontend developer into someone who blends engineering with AI/ML, building clean, fast interfaces and practical digital solutions across diverse projects.",
  closing: "I'm always eager to learn and innovate.",
  skills: ["UI/UX Design", "AI/ML Developer", "AI Agent Development", "Figma", "Python", "C++", "Next JS"]
};

export const projectsData = [
  {
    id: 1,
    title: "Tindog‑clone",
    description: "A clean HTML/CSS landing-page clone inspired by a modern pet-adoption service UI — demonstrates layout, responsive design, and attention to UI detail.",
    category: "Website",
    image: "https://portfolio-dusky-xi-88.vercel.app/images/works/Tindog_eyecatch.png",
    tags: ["UI Design", "Web Design", "Website"],
    color: "#FDF6E3",
    link: "https://tindogs-clone.netlify.app/"
  },
  {
    id: 2,
    title: "Tesla‑clone",
    description: "A modern landing-page clone replicating a premium brand’s site design — highlights capability to translate design into code, focus on layout, typography and responsiveness.",
    category: "Website",
    image: "https://portfolio-dusky-xi-88.vercel.app/images/works/Tesla_Works.png",
    tags: ["UX Research", "Website", "Cars"],
    color: "#E8E4FF",
    link: "https://teslaclones.netlify.app/"
  },
  {
    id: 3,
    title: "Drum Kit",
    description: "An in-browser audio-enabled drum kit application created with JS — a fun demo of event handling, media APIs, and interactive UI.",
    category: "Website",
    image: "https://portfolio-dusky-xi-88.vercel.app/images/works/Drumkit_eyecatch.png",
    tags: ["UI Design", "Web Design", "Website"],
    color: "#FFE4E4",
    link: "https://drum-kit-kshitij.netlify.app/"
  },
  {
    id: 4,
    title: "SkyRocket",
    description: "SkyRocket allows you to automate your buissness so you can focus on what's important.",
    category: "Web App",
    image: "https://portfolio-dusky-xi-88.vercel.app/images/works/SkyRocket_eyecatch.png",
    tags: ["UI Design", "Web Design", "Web App"],
    color: "#E4F5FF",
    link: "https://sky-rockets.netlify.app/"
  },
  {
    id: 5,
    title: "NewsMonkey",
    description: "A front-end news app that fetches and displays news articles dynamically — highlights API integration, asynchronous JS handling, and UI for real-time content.",
    category: "Web App",
    image: "https://i.ibb.co/M5gVZ2QC/news.png",
    tags: ["UI Design", "Web Design", "Web App"],
    color: "#E4F5FF",
    link: "https://sky-rockets.netlify.app/"
  },
  {
    id: 6,
    title: "Web3 Messaging App",
    description: "A web3 messaging app that allows you to send and receive messages on the blockchain.",
    category: "UI Design",
    image: "https://i.ibb.co/RTkqMqcP/App.png",
    tags: ["UI Design", "Web Design", "Web3"],
    color: "#E4F5FF",
    link: "https://www.figma.com/design/0hNWGwAtxdOM9DbzA3WLe8/Web3-Messaging-App?node-id=188-5061&t=4PTMVJMzu1mpzAJY-1"
  },
  {
    id: 7,
    title: "Anime Streaming Landing Page",
    description: "A landing page for an anime streaming website that allows you to watch anime online.",
    category: "UI Design",
    image: "https://i.ibb.co/Pzr4hdQb/anime.png",
    tags: ["UI Design", "Web Design", "Anime"],
    color: "#E4F5FF",
    link: "https://www.figma.com/design/FKxzz7HR09pcPrxV6UM62p/Anime-Streaming-Website-Landing-Page--Community---Copy-?node-id=2-24&t=4PTMVJMzu1mpzAJY-1"
  },
];

export const navigationLinks = [
  { name: "About", href: "#about" },
  { name: "Projects", href: "#projects" },
  { name: "Contact", href: "#contact" }
];
